import { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";

/* Admin sections are collapsed on arrival; each card remembers the choice after the first toggle. */
export const CollapsibleCard = ({
  title,
  count,
  icon: Icon,
  storageKey,
  children,
  testid,
  actions,
}) => {
  const [open, setOpen] = useState(() => localStorage.getItem(`card:${storageKey}`) === "1");

  useEffect(() => {
    localStorage.setItem(`card:${storageKey}`, open ? "1" : "0");
  }, [open, storageKey]);

  return (
    <div className="border border-zinc-800 bg-zinc-900/30" data-testid={testid}>
      <button
        type="button"
        data-testid={testid ? `${testid}-toggle` : undefined}
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-2 px-4 py-3 text-left transition-colors duration-200 hover:bg-zinc-900/60"
      >
        {Icon && <Icon className="h-4 w-4 text-zinc-400 shrink-0" />}
        <span className="font-heading text-sm font-semibold tracking-tight text-zinc-100">
          {title}
        </span>
        {count !== undefined && count !== null && (
          <span className="font-mono text-[11px] text-zinc-500">({count})</span>
        )}
        <ChevronDown
          className={`ml-auto h-4 w-4 text-zinc-400 shrink-0 transition-transform duration-200 ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>
      {open && (
        <div className="border-t border-zinc-800" data-testid={testid ? `${testid}-body` : undefined}>
          {actions}
          {children}
        </div>
      )}
    </div>
  );
};
